export const DuplicateEventsRemove = (allEvents) => {
    const uniqueEvents = [];
    const ids = new Set();

    allEvents.forEach(item => {
        if (!ids.has(item.id)) {
            ids.add(item.id);
            uniqueEvents.push(item);
        }
    });

    return uniqueEvents;
}

export const testingObjAllEventsSpecificeEstate = [

    {
        confirmedEvents: [
            {
                id: 1,
                eventTitle: "Visites confirmés",
                eventSubTitle: "Prochaine visite",
                eventCount: 23,
                agentName: "Michael Loraine",
                eventDurationTime: "17:00 - 17:30",
                eventDateTime: "Mardi 04 Août 2025",
            },
            {
                id: 2,
                eventTitle: "Visites confirmés",
                eventSubTitle: "Prochaine visite",
                eventCount: 23,
                agentName: "Michael Loraine",
                eventDurationTime: "09:00 - 09:30",
                eventDateTime: "Mardi 04 Août 2025",
            },
            {
                id: 3,
                eventTitle: "Visites confirmés",
                eventSubTitle: "Prochaine visite",
                eventCount: 23,
                agentName: "Michael Loraine",
                eventDurationTime: "09:00 - 09:30",
                eventDateTime: "Mardi 04 Août 2025",
            },
        ]
    },
    {
        freeSlotEvents: [
            {
                id: 1,
                eventTitle: "Créneaux libres",
                eventSubTitle: "Créneau libre",
                eventCount: 34,
                agentName: "Michael Loraine",
                eventDurationTime: "09:00 - 09:30",
                eventDateTime: "Mardi 04 Août 2025",
            }
        ],
    },
    {
        toBeConfirmedEvents: [
            {
                id: 1,
                eventTitle: "Visite a confirmé",
                eventSubTitle: "",
                eventCount: 23,
                agentName: "Michael Loraine",
                contactFirstName: "Abdul",
                contactName: "Rahman",
                contactLanguage: "en-GB",
                eventDurationTime: "12:00 - 12:30",
                eventDateTime: "Mardi 04 Août 2025",
                // ── URL params for /eventhandler route ──────────────────────────────
                // /eventhandler/:contactId/:eventId/:clientId/:officeId/:contactFirstName/:contactName/:contactLanguage/:estateId/:agentId/:internalEventId
                contactId: "42390561",
                eventId: "62782993",
                clientId: "11613",
                officeId: "14331",
                estateId: "6521728",
                agentId: "47170",
                internalEventId: "4210",
            },
            {
                id: 2,
                eventTitle: "Visite a confirmé",
                eventSubTitle: "",
                eventCount: 23,
                agentName: "Michael Loraine",
                contactFirstName: "Abdul",
                contactName: "Rahman",
                contactLanguage: "en-GB",
                eventDurationTime: "09:00 - 09:30",
                eventDateTime: "Mardi 04 Août 2025",
                // ── URL params for /eventhandler route ──────────────────────────────
                contactId: "42390561",
                eventId: "62782993",
                clientId: "11613",
                officeId: "14331",
                estateId: "6521728",
                agentId: "47170",
                internalEventId: "4210",
            },
        ],
    }
]
